import { createAction, props } from '@ngrx/store';
export const setIncludeEmptyFolders = createAction('[Folders] Set Include Empty Folders', props());
